export default __webpack_public_path__ + "static/media/googleAssistant.1c231255.svg";